import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'excerpt',
  pure: false
})
export class ExcerptPipe implements PipeTransform {
  transform(text: string | null, length: number | null): string {
    if (!text || !length) {
      return '';
    }

    if (text.length > length) {
      return text.substring(0, length) + '...';
    }

    return text;
  }
}
